import { Eye } from "lucide-react";
import type * as React from "react";

import { Button } from "@/shared/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shared/components/ui/popover";
import { cn } from "@/shared/lib/utils";

export const editedFieldHighlight =
  "rounded-md ring-1 ring-amber-500/50 ring-offset-0";

interface OriginalValueIndicatorProps {
  label: string;
  original: React.ReactNode;
  wide?: boolean;
}

export function OriginalValueIndicator({
  label,
  original,
  wide,
}: OriginalValueIndicatorProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          aria-label={`View original ${label}`}
          className="h-6 gap-1 px-1.5 text-amber-700 hover:text-amber-800 hover:bg-amber-100/60 dark:text-amber-400 dark:hover:text-amber-300 dark:hover:bg-amber-950/40"
        >
          <Eye className="size-3.5" />
          <span className="text-[10px] font-medium uppercase tracking-wide">
            edited
          </span>
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        sideOffset={6}
        className={cn("p-3", wide ? "w-[420px] max-w-[80vw]" : "w-[280px]")}
      >
        <p className="text-[10.5px] font-semibold uppercase tracking-wide text-muted-foreground mb-1.5">
          Original {label}
        </p>
        <div
          className={cn(
            "text-sm text-foreground",
            wide
              ? "max-h-64 overflow-auto whitespace-pre-wrap break-words"
              : "break-words",
          )}
        >
          {original}
        </div>
      </PopoverContent>
    </Popover>
  );
}
